import React, { useState } from "react";
import { FaCheckCircle } from "react-icons/fa";
import { IoCheckmarkCircle, IoCopyOutline } from "react-icons/io5";
import { RxCross2 } from "react-icons/rx";
import { Button } from "../CustomComponents";
import ModalContainer from "../ModalContainer";
import cssStyles from "./styles/VideoLinkModal.module.scss";

import moment from "moment";
import { Spinner } from "react-bootstrap";
import { useEnrollClassMutation } from "../../Data/services/classesApi";
import { ErrorToast, SuccessToast } from "../../Hooks/useToast";
import { BsFillCheckCircleFill } from "react-icons/bs";

const VideoLinkModal = ({ handleModalClose, data, refetch, hasAccess = true, isAttendSubmitted = false, handleAttendClass }) => {
  const [copied, setCopied] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [enrollClass] = useEnrollClassMutation();

  const handleCopyClick = () => {
    navigator.clipboard.writeText(data?.meeting_link).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000); // Reset copied state after 2 seconds
    });
  };


  const handleEnrollClass = async () => {
    if (isLoading) return;
    try {
      setIsLoading(true)
      await enrollClass({ class_id: data?.id }).unwrap()
      SuccessToast("Successfully enrolled in class")
      handleModalClose()
    }
    catch (err) {
      ErrorToast(err.data?.message || "Something went wrong. Please try again later")
      setIsLoading(false)
    }
  }

  return (
    <div>
      <ModalContainer handleClose={handleModalClose}>
        <div className={cssStyles.modalContainer}>
          <span
            className={`bg-category-bg shadow d-flex p-2 rounded-5 ${cssStyles.closeBtn}`}
          >
            <RxCross2
              role="button"
              onClick={handleModalClose}
              style={{ cursor: "pointer" }}
            />
          </span>
          <div className="d-flex  align-items-center w-100 justify-content-between ">
            <p className="fs-2 fw-bold fw-medium m-auto">{data?.title}</p>
          </div>

          <div className="d-flex flex-column justify-content-between align-items-center">
            <div className="fs-6 primary-bg rounded-5 px-3 py-1 text-white m-2">
              You have Attend Online Class
            </div>

            <div className="my-3 d-flex flex-column align-items-center">
              <img
                src={"/images/profile.png"}
                alt="Logo"
                className={cssStyles.profileImage}
              />

              <div className="fs-2 fw-bold">{data?.host_name}</div>
              <div className="fs-4 fw-light">{data?.host_designation}</div>

              <div className="d-flex flex-wrap justify-content-center">
                <div className="p-2 px-3 m-2 rounded-4 grayBg fs-6 fw-light">
                  <img
                    alt="visit video"
                    src="/images/video.svg"
                    width={30}
                    className="me-2"
                  />
                  Video Visit
                </div>

                <div className="p-2 px-3 m-2 rounded-4 grayBg fs-6 fw-light">
                  <img
                    alt="visit video"
                    src="/images/expertise.svg"
                    width={30}
                    className="me-2"
                  />
                  {data?.host_experience} Year Experience
                </div>
              </div>

              <div className="d-flex flex-wrap justify-content-center">
                <div className="p-2 px-3 m-2 rounded-4 grayBg fs-6 fw-light">
                  <img
                    alt="visit video"
                    src="/images/watch.svg"
                    width={30}
                    className="me-2"
                  />
                  {moment(data?.start_at)?.format('hh:mm A')}
                </div>

                <div className="p-2 px-3 m-2 rounded-4 grayBg fs-6 fw-light">
                  <img
                    alt="visit video"
                    src="/images/calendar.svg"
                    width={30}
                    className="me-2"
                  />
                  {moment(data?.start_at)?.format('dddd DD MMM, YYYY')}
                </div>
              </div>
            </div>

            <div className="fs-4 fw-light mt-2">Join Zoom Meeting</div>

            <div className="p-2 px-3 m-2 rounded-4 grayBg  d-flex">
              <img
                alt="visit video"
                src="/images/zoom.svg"
                width={30}
                className="me-2"
              />
              <span className="px-2 fs-6">{data?.meeting_link}</span>
              {
                // <img
                //   alt="visit video"
                //   src="/images/copy.svg"
                //   width={20}
                //   className="ms-2"
                //   style={{ cursor: "pointer" }}
                //   onClick={handleCopyClick}
                // />
              }
              {copied ? (
                <FaCheckCircle size={20} color="green" className="ms-2" />
              ) : (
                <IoCopyOutline
                  size={20}
                  className="ms-2 icon-fade"
                  style={{ cursor: "pointer" }}
                  onClick={handleCopyClick}
                />
              )}
            </div>
            {

              data?.is_completed ?
                <Button
                  text={<span className="d-flex align-items-center justify-content-center gap-2">Completed<IoCheckmarkCircle size={25} /></span>}
                  classes="gradientBg rounded-5 fw-bold mt-3"
                /> :
                data?.is_enrolled ?
                  <Button
                    classes="gradientBg rounded-5 fw-bold mt-3"
                    onClick={handleAttendClass}
                    text={
                      isAttendSubmitted ? <Spinner /> :
                        <div>
                          <BsFillCheckCircleFill size={24} /> Attend
                        </div>
                    }
                  /> :
                  !hasAccess ? <p className="my-4">Already Enrolled In Another Class</p> :
                    <Button
                      text={isLoading ? <Spinner color="white" /> : "Enroll now"}
                      classes="gradientBg rounded-5 fw-bold mt-3"
                      onClick={handleEnrollClass}
                    />
            }
          </div>
        </div>
      </ModalContainer>
    </div>
  );
};

export default VideoLinkModal;
